<div class="innerpage-fullwithbanner">
  <ng-container>
    <h2 class="bighead" *ngIf="!isInEditMode">Add New Property</h2>
    <h2 class="bighead" *ngIf="isInEditMode">Edit Property Details</h2>
  </ng-container>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li>
      <a (click)="onBreadCrumbClick();">{{this.prevPage}}<span>|</span></a>
    </li>
    <ng-container>
      <li *ngIf="!isInEditMode">Add New Property</li>
      <li *ngIf="isInEditMode">Edit Property</li>
    </ng-container>
  </ul>
</div>
<div class="container container-lg" style="margin-top:80px;">
  <div class="wizard-border">
    <div class="cf timeline-wrap">
      <ul class="wizardstyle5 clearfix">
        <li [ngClass]="{'success' : firstDivCompleted && activeDiv !=1 , 'active':activeDiv == 1, 'partial' : firstDivPartiallyCompleted && activeDiv !=1, 'inactive': activeDiv != 1 && !firstDivCompleted && !firstDivPartiallyCompleted, 'currentDiv': activeDiv>=1}" (click)="SetActiveDiv(1)">
          <div class="wizard-stpes">
            <div>
              <div *ngIf="!firstDivCompleted || activeDiv == 1" class="blueborder-circle">
                <p>1</p>
              </div>
              <div *ngIf="firstDivCompleted && activeDiv != 1" class="blueborder-circle">
                <span></span>
              </div>
            </div>
            <div class="wizard-label d-flex">
              <p class="be-labe">Step 1/4</p>
              <p class="step">Tenant & Location</p>
            </div>
          </div>
        </li>
        <li [ngClass]="{'success' : secondDivCompleted && activeDiv !=2 , 'active':activeDiv == 2, 'partial' : secondDivPartiallyCompleted && activeDiv !=2, 'inactive': activeDiv != 2 && !secondDivCompleted && !secondDivPartiallyCompleted, 'currentDiv': activeDiv>=2 }" (click)="SetActiveDiv(2)">
          <div class="wizard-stpes">
            <div>
              <div *ngIf="!secondDivCompleted || activeDiv == 2" class="blueborder-circle">
                <p>2</p>
              </div>
              <div *ngIf="secondDivCompleted && activeDiv != 2" class="blueborder-circle">
                <span></span>
              </div>
            </div>
            <div class="wizard-label d-flex">
              <p class="be-labe">Step 2/4</p>
              <p class="step">Property & Lease</p>
            </div>
          </div>
        </li>
        <li [ngClass]="{'success' : thirdDivCompleted && activeDiv != 3 , 'active':activeDiv == 3, 'inactive': activeDiv != 3 && !thirdDivCompleted, 'currentDiv': activeDiv>=3 }" (click)="SetActiveDiv(3)">
          <div class="wizard-stpes">
            <div>
              <div *ngIf="!thirdDivCompleted || activeDiv == 3" class="blueborder-circle">
                <p>3</p>
              </div>
              <div *ngIf="thirdDivCompleted && activeDiv != 3" class="blueborder-circle">
                <span></span>
              </div>
            </div>
            <div class="wizard-label d-flex">
              <p class="be-labe">Step 3/4</p>
              <p class="step">Financials</p>
            </div>
          </div>
        </li>
        <li [ngClass]="{'success' : fourthDivCompleted && activeDiv != 4 , 'active':activeDiv == 4, 'inactive': activeDiv != 4 && !fourthDivCompleted, 'currentDiv': activeDiv>=4 }" (click)="SetActiveDiv(4)">
          <div class="wizard-stpes">
            <div>
              <div *ngIf="!fourthDivCompleted || activeDiv == 4" class="blueborder-circle">
                <p>4</p>
              </div>
              <div *ngIf="fourthDivCompleted && activeDiv != 4" class="blueborder-circle">
                <span></span>
              </div>
            </div>
            <div class="wizard-label d-flex">
              <p class="be-labe">Step 4/4</p>
              <p class="step">Documents & Media</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<form [formGroup]="propForm" autocomplete="off" #formDir="ngForm" name="form" class="property-form">
  <div class="container container-lg margin-top-20">
    <div class="FirstDiv" [style.display]="activeDiv==1 ? 'block' : 'none'">
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Tenant Information</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                Tenant
                <span class="star">*</span>
                <label class="custom-checkbox" style="float:right; height:10px">
                  <input formControlName="chkNewTenantInfo" #newTenantInfo [(ngModel)]="model.IsNewTenant" id="checkbox12" type="checkbox" (click)="checkNewTenant(newTenantInfo.checked)">
                  <i class="helper"></i> New Tenant
                </label>
              </label>
              <!--<ng2-completer [hidden]="model.IsNewTenant" [class.error-input]="getnullableInput('TenantName')" [(ngModel)]="model.TenantName" [textSearching]="model.TenantName" [maxChars]="90" [datasource]="dataService"
              formControlName="txtTenantName" (selected)="onTenantSelect($event)" [overrideSuggested]="true" [minSearchLength]="0" (blur)="onTenantBlur($event)"></ng2-completer>-->
              <!--<ng-select [hidden]="model.IsNewTenant" [class.error-input]="getnullableInput('TenantName')" [(ngModel)]="model.TenantName" [items]="dataService" class="form-control" [searchable]="true" (blur)="onTenantBlur($event)" [virtualScroll]="true" [minTermLength]="0" (change)="onTenantSelect($event)"></ng-select>-->
              <ng-select [items]="dataService$ | async"
                         bindLabel="TenantName"
                         bindValue="TenantName"
                         formControlName="txtTenantName"
                         [hideSelected]="true"
                         [loading]="loading"
                         (change)="onTenantSelect($event)"
                         [typeahead]="dataServiceInput$"
                         [minTermLength]="0"
                         [(ngModel)]="model.TenantName" [class.error-input]="getnullableInput('TenantName')" [ngModelOptions]="{standalone: true}" *ngIf="!model.IsNewTenant">
              </ng-select>
              <!--<mat-form-field *ngIf="!model.IsNewTenant">
                <mat-select (close)="onTenantBlur($event)"
                            [(ngModel)]="model.TenantName"
                            [ngModelOptions]="{standalone: true}"
                            (selectionChange)="onTenantSelect($event.value)"
                            placeholder="Search Tenant"
                            panelClass="dynamic-width">
                  <mat-option>
                    <ngx-mat-select-search [disableInitialFocus]="true"
                                           [hideClearSearchButton]="true"
                                           [clearSearchInput]="false"
                                           [searching]="loading"
                                           placeholderLabel="Search here.."
                                           #searchKey
                                           (input)="dataServiceInput$.next(searchKey.value);"
                                           noEntriesFoundLabel="Nothing found..">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (item of dataService$ | async; track $index) {
                  <mat-option [value]="item">{{item.TenantName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>-->

              <input type="text" maxlength="100" [class.error-input]="getnullableInput('TenantNameText')" *ngIf="model.IsNewTenant" class="form-control" formControlName="txtTenantNameFreeText" [(ngModel)]="model.TenantNameText" />

              <div>
                <p class="redtext" *ngIf="!model.TenantName && isSubmitted && !model.IsNewTenant">
                  Tenant name is required
                </p>
                <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && !model.IsNewTenant">
                  The value cannot be only white spaces
                </p>
                <p class="redtext" *ngIf="!model.TenantNameText && isSubmitted && model.IsNewTenant">
                  Tenant name is required
                </p>
                <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && model.IsNewTenant">
                  The value cannot be only white spaces
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">

            <div class="form-group">
              <label class="form-label">
                Guarantor
                <label class="custom-checkbox" style="float:right; height:10px">
                  <input formControlName="chkGurantorInfo" #newGuarantor [(ngModel)]="model.IsNewGuarantor" id="checkbox12" (click)="checkNewGuarantor(newGuarantor.checked)" type="checkbox"> New Guarantor
                  <i></i>
                </label>
              </label>
              <label class="select" *ngIf="!model.IsNewGuarantor">
                <select class="form-control" formControlName="drpGuarantor" (change)="onGuarantorChanges();" [(ngModel)]="model.GuarantorId">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let guarantor of guarantorList" [(ngValue)]="guarantor.Id">{{guarantor.Name}}</option>
                </select>
                <i></i>
              </label>
              <input type="text" maxlength="100" *ngIf="model.IsNewGuarantor" class="form-control" formControlName="txtGuarantorNameText" [(ngModel)]="model.GuarantorName" />

            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label hidden-xs hidden-sm">&nbsp;</label>
              <div role="group" class="form-radio">
                <div class="radio radio-inline">
                  <label>
                    <input id="Franchisee" type="radio" value="Franchisee" [checked]="!isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('fr')">
                    <i class="helper"></i>Franchisee
                  </label>
                </div>
                <div class="radio radio-inline">
                  <label>
                    <input id="Corporate" type="radio" value="Corporate" [checked]="isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('cr')">
                    <i class="helper"></i>Corporate
                  </label>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="row" role="group" aria-labelledby="_rating">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label class="bluelabel">
              TENANT CREDIT
            </label>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">S&amp;P Rating</label>
                  <label class="select">
                    <select formControlName="lstSandP" [(ngModel)]="model.SPRatingId" class="form-control ">
                      <option [value]="null">Select</option>
                      <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
                    </select>
                    <i></i>
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Moody's Rating</label>
                  <label class="select">
                    <select formControlName="lstMoodyRating" [(ngModel)]="model.MoodyRatingId"
                            class="form-control ">
                      <option [value]="null">Select</option>
                      <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
                    </select>
                    <i></i>
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group ">
                  <label class="form-label">Fitch Rating</label>
                  <label class="select">
                    <select formControlName="fitchRating" [(ngModel)]="model.FitchRatingId"
                            class="form-control">
                      <option [value]="null">Select</option>
                      <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
                    </select>
                    <i></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" role="group" aria-labelledby="_rating">
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Number of Units
              </label>
              <input type="text" mask="99999" [class.error-input]="getnullableInput('NoOfUnits')" formControlName="txtNumberOfUnits" [min]="isFranchise ? 1 : 0"
                     [(ngModel)]="model.NoOfUnits" class="form-control ">
              <div *ngIf="((txtNumberOfUnits.invalid && isSubmitted)||(txtNumberOfUnits.invalid && (txtNumberOfUnits.dirty || txtNumberOfUnits.touched)))">
                <p class="redtext" *ngIf="txtNumberOfUnits.errors.required">Enter number of franchicies</p>
                <p class="redtext" *ngIf="txtNumberOfUnits.errors.min">Number of units must be greater than 0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Location</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Street Address
                <span class="star">*</span>
              </label>
              <input [(ngModel)]="model.Address" [class.error-input1]="getnullableInput('Address')" #addresstext (change)="onDuplicateChecking();" formControlName="txtAddress" name="txtAddress" required maxlength="190" type="text" class="form-control" (ngModelChange)="onStreetAddressChange()">
              <div *ngIf="((txtAddress.invalid && isSubmitted)||(txtAddress.invalid && (txtAddress.dirty || txtAddress.touched)))">
                <p class="redtext" *ngIf="txtAddress.errors.spaceOnly">
                  The value cannot be only white spaces
                </p>
                <p class="redtext" *ngIf="txtAddress.errors.required">
                  Address is required
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                State
                <span class="star">*</span>
              </label>
              <label class="select">
                <select class="form-control" formControlName="lstState" [class.error-input]="getnullableInput('StateId')" (change)="bindCity()" [(ngModel)]="model.StateId">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let state of statesList" [(ngValue)]="state.Id">{{state.Name}}</option>
                </select>
                <i></i>
              </label>
              <div *ngIf="((lstState.invalid && isSubmitted)||(lstState.invalid && (lstState.dirty || lstState.touched)))">
                <p class="redtext" *ngIf="lstState.errors.required">
                  State is required
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                City
                <span class="star">*</span>
              </label>
              <label class="select">
                <select formControlName="lstCity" [class.error-input]="getnullableInput('CityId')" [(ngModel)]="model.CityId" class="form-control " (change)="callZipChange($event)">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let city of citiesList" [(ngValue)]="city.Id">{{city.Name}}</option>
                </select>
                <i></i>
              </label>
              <div *ngIf="((lstCity.invalid && isSubmitted) ||(lstCity.invalid && (lstCity.dirty || lstCity.touched)))">
                <p class="redtext" *ngIf="lstCity.errors.required">
                  City is required
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Zip
                <span class="star">*</span>
              </label>
              <input formControlName="txtZip" [class.error-input]="getnullableInput('Zip')" (change)="callZipChange($event)" [(ngModel)]="model.Zip" maxlength="10" mask="00000" required
                     type="text" class="form-control ">

              <div *ngIf="((txtZip.invalid && isSubmitted) || (txtZip.invalid && (txtZip.dirty || txtZip.touched)))">
                <p class="redtext" *ngIf="txtZip.errors.required">
                  Zip is required
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row d-none">

        </div>
        <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
          <h5 class="mr-auto margin-bottom-0">
            <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
              <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
            </i>
            <span>Select Street Address From Google Maps Dropdown For Best Results</span>
          </h5>
        </div>
        <div class="mapdiv">
          <input type="hidden" formControlName="lat" [(ngModel)]="model.Latitude">
          <input type="hidden" formControlName="lon" [(ngModel)]="model.Longitude">
          <div #gmap style="width:100%;height:350px"></div>
        </div>
      </div>
    </div>
    <div class="SecondDiv" [style.display]="activeDiv==2 ? 'block' : 'none'">
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Property Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Year Built
                <span class="star">*</span>
              </label>
              <input type="text" mask="0000" formControlName="txtYearBuilt" [class.error-input]="getnullableInput('YearBuilt')" [min]="1850" [max]="today.getFullYear()" [required]="model.PropertyStatusId!=6906" [(ngModel)]="model.YearBuilt"
                     class="form-control ">
              <div *ngIf="((txtYearBuilt.invalid && isSubmitted) || (txtYearBuilt.invalid && (txtYearBuilt.dirty || txtYearBuilt.touched)))">
                <p class="redtext" *ngIf="txtYearBuilt.errors.required">
                  Year of built is required
                </p>
                <p class="redtext" *ngIf="txtYearBuilt.errors.min">The year of built must be greater or equal to 1850</p>
                <p class="redtext" *ngIf="txtYearBuilt.errors.max">
                  The year cannot be greater than {{today.getFullYear()}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Renovated
              </label>
              <input type="text" mask="0000" [class.error-input]="getnullableInput('Renovated')" formControlName="txtRenovated" ng-minlength="4" [min]="model.YearBuilt" [(ngModel)]="model.Renovated"
                     class="form-control">
              <div *ngIf="((txtRenovated.invalid && isSubmitted) || (txtRenovated.invalid && (txtRenovated.dirty || txtRenovated.touched)))">
                <p class="redtext" *ngIf="txtRenovated.errors.minlength">
                  Please enter a valid year
                </p>
                <p class="redtext" *ngIf="(model.Renovated.length==4) && (txtRenovated.errors.minValue)">
                  <!--The year cannot be less than {{model.YearBuilt}}-->
                  The renovated year cannot be less than year of built
                </p>

                <p class="redtext" *ngIf="txtRenovated.errors.max">
                  The year cannot be greater than {{today.getFullYear()}}
                </p>

              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Building SF
                <span class="star">*</span>
              </label>
              <div class="textbox-with-4character textbox-with-btn">
                <input type="text" inputmode="numeric" [class.error-input]="isSubmitted && getnullableInput('BuildingSize')" class="form-control" formControlName="txtBuildingSF" min="1" [min]="1" maxlength="18" dropSpecialCharacters="false" mask="separator.10.2" thousandSeparator=","
                       [(ngModel)]="model.BuildingSize" (change)="validationService.onlyDecimal($event);" (keyup)="updatePSF()">

                <!--<input type="text" class="form-control" [class.error-input]="getnullableInput('BuildingSize')" name="txtBuildingSF" min="1" [min]="1" dropSpecialCharacters="false" mask="999999999.99" formControlName="txtBuildingSF"
                       [(ngModel)]="model.BuildingSize" (change)="validationService.onlyDecimal($event);" (keyup)="updatePSF()" value="{{model.BuildingSize|number}}">-->
                <span class="rightlabel">SQ FT</span>
              </div>
              <div *ngIf="isSubmitted && ((txtBuildingSF.invalid && isSubmitted)||(txtBuildingSF.invalid && (txtBuildingSF.dirty || txtBuildingSF.touched)))">
                <p class="redtext" *ngIf="txtBuildingSF.errors.required">
                  Building size is required
                </p>
                <p class="redtext" *ngIf="txtBuildingSF.errors.min">
                  Building size should be greater than 0
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Land (AC)
                <span class="star" *ngIf="model.PropertyStatusId==6906">*</span>
              </label>
              <div class="textbox-with-4character textbox-with-btn">
                <input min="0.001" [min]="0.001" [class.error-input]="getnullableInput('Land')" type="text" mask="999999999.99" [dropSpecialCharacters]="false" formControlName="txtland" name="land" [(ngModel)]="model.Land"
                       class="form-control " (change)="validationService.onlyDecimal($event);">
                <span class="rightlabel">acre</span>
              </div>
              <div *ngIf="((txtland.invalid && isSubmitted)||(txtland.invalid && (txtland.dirty || txtland.touched)))">
                <p class="redtext" *ngIf="txtland.errors.required">
                  Land (AC) is required
                </p>
                <p class="redtext" *ngIf="txtland.errors.min">
                  Land area should be greater than 0
                </p>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Property Type
                <span class="star">*</span>
              </label>

              <div class="select-dropdown multiselectdesign">
                <mat-form-field>
                  <mat-select formControlName="lstPropertyType" [class.error-input]="getnullableInput('PropertyTypeList')"
                              [(ngModel)]="model.PropertyTypeList" placeholder="Select" (ngModelChange)="bindSubCategories($event)" multiple>
                    @if (model?.PropertyTypeList.length > 1) {
                    <mat-select-trigger (click)="$event.stopPropagation()">
                      <span>{{ model?.PropertyTypeList.length }} items selected</span>
                    </mat-select-trigger>
                    }
                    @for (item of propertyTypesList; track item) {
                    <mat-option [value]="item.id" class="multi-dropdown-item">{{item.name}}</mat-option>
                    }
                    @if (propertyTypesList.length === 0) {
                    <mat-option class="matoptionnodata" disabled>
                      Nothing found...
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="((lstPropertyType.invalid && isSubmitted))">
                <p class="redtext" *ngIf="lstPropertyType.errors.required">
                  Property type is required
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Subcategory
                <span class="star" *ngIf="model.PropertyStatusId==6906">*</span>
              </label>
              <div class="select-dropdown multiselectdesign">
                <mat-form-field>
                  <mat-select formControlName="lstSubcatgeories" [class.error-input]="getnullableInput('PropertyTypeSubcategoryList')"
                              [(ngModel)]="model.PropertyTypeSubcategoryList" placeholder="Select" (selectionChange)="bindSubCategories($event.value)" multiple>
                    @if (model?.PropertyTypeSubcategoryList?.length > 1) {
                    <mat-select-trigger>
                      <span>{{ model?.PropertyTypeSubcategoryList?.length }} items selected</span>
                    </mat-select-trigger>
                    }
                    @for (item of subCategoriesList; track $index) {
                    <mat-option [value]="item.id" class="multi-dropdown-item">{{item.name}}</mat-option>
                    }
                    @if (subCategoriesList.length === 0) {
                    <mat-option class="matoptionnodata" disabled>
                      Nothing found...
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="(lstSubcatgeories.invalid && isSubmitted)">
                <p class="redtext" *ngIf="lstSubcatgeories.errors.required">
                  Subcategory is required
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Lease Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Lease Structure
                <span class="star">*</span>
              </label>
              <label class="select">
                <select class="form-control" [class.error-input]="getnullableInput('LeaseStructureId')" formControlName="lstLeaseStructure" [(ngModel)]="model.LeaseStructureId">
                  <option [ngValue]="null">Select</option>
                  <option [ngValue]="str.id" *ngFor="let str of leaseStructureList">{{str.description}}</option>
                </select>
                <i></i>
              </label>
              <div *ngIf="((lstLeaseStructure.invalid && isSubmitted) ||(lstLeaseStructure.invalid && (lstLeaseStructure.dirty || lstLeaseStructure.touched)))">
                <p class="redtext" *ngIf="lstLeaseStructure.errors.required">
                  Lease structure is required
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Ownership Type
                <span class="star">*</span>
              </label>
              <label class="select">
                <select class="form-control" [class.error-input]="getnullableInput('OwnershipTypeId')" formControlName="lstOwnershipType" [(ngModel)]="model.OwnershipTypeId">
                  <option [ngValue]="null">Select</option>
                  <option [ngValue]="item.id" *ngFor="let item of ownershipList">{{item.description}}</option>
                </select>
                <i></i>
              </label>
              <div *ngIf="((lstOwnershipType.invalid && isSubmitted)|| (lstOwnershipType.invalid && (lstOwnershipType.dirty || lstOwnershipType.touched)))">
                <p class="redtext" *ngIf="lstOwnershipType.errors.required">
                  Ownership type is required
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <label class="bluelabel">Rent</label>
          </div>
          <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-sm-12 col-xs-12">
            <div class="row">
              <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-sm-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-xs-12">
                <div class="form-group">
                  <label class="form-label">
                    Rent / NOI
                    <span class="star">*</span>
                  </label>
                  <div class="textbox-with-btn-left">
                    <input formControlName="txtNOI" [(ngModel)]="model.NOI" [class.error-input]="getnullableInput('NOI')" [min]="0" required="required" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
                           dropSpecialCharacters="false" class="form-control " (keyup)="updateCapRate('NOI')" value="{{model.NOI|number}}" (ngModelChange)="propertyRentTermsFielsChange()">
                    <span class="leftlabel">$</span>
                  </div>
                  <div *ngIf="((txtNOI.invalid && isSubmitted)||(txtNOI.invalid && (txtNOI.dirty || txtNOI.touched)))">
                    <p class="redtext" *ngIf="txtNOI.errors.required">
                      Rent / NOI is required
                    </p>
                    <p class="redtext" *ngIf="txtNOI.errors.min">
                      Rent / NOI value should be greater than 0
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                RPSF
                <span class="star" *ngIf="model.PropertyStatusId!=6906">*</span>
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" disabled dropSpecialCharacters="false" mask="separator.10.2" thousandSeparator="," formControlName="txtPSF" [class.error-input]="getnullableInput('LeasePricePSF')" [attr.disabled]="'disabled'"
                       [(ngModel)]="model.LeasePricePSF" class="form-control " maxlength="21" (change)="validationService.onlyDecimal($event);">

                <span class="leftlabel">$</span>
              </div>
              <div *ngIf="((txtPSF.invalid && isSubmitted)||(txtPSF.invalid && (txtPSF.dirty || txtPSF.touched)))">
                <p class="redtext" *ngIf="txtPSF.errors.required">
                  RPSF is required
                </p>
                <p class="redtext" *ngIf="txtPSF.errors.min">
                  RPSF value should be greater than 0
                </p>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label class="bluelabel">Lease (Date)</label>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">
                    Commencement
                    <span class="star">*</span>
                  </label>
                  <div class="textbox-date">
                    <input type="text" maxlength="10" [class.error-input]="getnullableInput('LeaseCommencementDate')" name="txtCommencement" formControlName="txtCommencement" (change)="onLeaseDatesChange($event)"
                           [min]="model.YearBuilt" [(ngModel)]="model.LeaseCommencementDate" required="required"
                           class="form-control" bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <div *ngIf="((txtCommencement.invalid && isSubmitted)||(txtCommencement.invalid && (txtCommencement.dirty || txtCommencement.touched)))">
                    <p class="redtext" *ngIf="txtCommencement.errors.required">
                      Commencement date is required
                    </p>
                    <p class="redtext" *ngIf="txtCommencement.errors.minYear">
                      Commencement date should be after the year of built
                    </p>
                    <p class="redtext" *ngIf="txtCommencement.errors.maxDate">
                      Commencement date should be in the past
                    </p>
                    <p class="redtext" *ngIf="model.LeaseCommencementDate =='Invalid Date'">
                      Please enter a valid date
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">
                    Expiration
                    <span class="star">*</span>
                  </label>
                  <div class="textbox-date">
                    <input type="text" maxlength="10" [class.error-input]="getnullableInput('LeaseExpiration')" [min]="model.YearBuilt" formControlName="txtExpiration" (change)="onLeaseDatesChange($event)"
                           [(ngModel)]="model.LeaseExpiration" name="txtExpiration" required="required" class="form-control"
                           bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <div *ngIf="((txtExpiration.invalid && isSubmitted)||(txtExpiration.invalid && (txtExpiration.dirty || txtExpiration.touched)))">
                    <p class="redtext" *ngIf="txtExpiration.errors.required">
                      Lease expiration date is required
                    </p>
                    <p class="redtext" *ngIf="txtExpiration.errors.minDate">
                      Lease expiration date should be after the commencement date
                    </p>
                    <p class="redtext" *ngIf="model.LeaseExpiration =='Invalid Date'">
                      Please enter a valid date
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label class="bluelabel">
              Term (in years)
            </label>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">
                    Original
                    <span class="star" *ngIf="model.PropertyStatusId!=6906">*</span>
                  </label>
                  <div class="textbox-with-btn textbox-with-4character">
                    <input type="hidden" formControlName="txtOriginalHdn" [(ngModel)]="model.OriginalLeaseTerm" />
                    <input type="text" mask="9999" [class.error-input]="getnullableInput('OriginalLeaseTerm')" disabled formControlName="txtOriginal" min="0" [value]="[model.LeaseExpiration | yearsGapBetweenDates: model.LeaseCommencementDate]"
                           class="form-control ">
                    <!-- <span class="rightlabel">Years</span> -->
                  </div>
                  <div *ngIf="((txtOriginal.invalid && isSubmitted)||(txtOriginal.invalid && (txtOriginal.dirty || txtOriginal.touched)))">
                    <p class="redtext" *ngIf="txtOriginal.errors.required">
                      Original term is required
                    </p>
                    <p class="redtext" *ngIf="txtOriginal.errors.min">
                      Original term should be greater than 0
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Remaining</label>
                  <div class="textbox-with-btn textbox-with-4character">
                    <input type="text" disabled="disabled" [value]="[model.LeaseExpiration | propRemainingTerm: model.LeaseCommencementDate]"
                           class="form-control">
                    <!-- <span class="rightlabel">Years</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label class="bluelabel">Escalation</label>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Percentage</label>
                  <div class="textbox-with-btn textbox-with-2character">
                    <input formControlName="txtEscalationPercentage" [class.error-input]="getnullableInput('RentEscalationPercentage')" [max]="100" [min]="0" [(ngModel)]="model.RentEscalationPercentage" type="text"
                           [dropSpecialCharacters]="false" mask="999.99" class="form-control" (change)="validationService.onlyDecimal($event);" (ngModelChange)="propertyRentTermsFielsChange()">
                    <span class="rightlabel">%</span>
                  </div>
                  <div *ngIf="(txtEscalationPercentage.invalid && isSubmitted)||(txtEscalationPercentage.invalid && (txtEscalationPercentage.dirty || txtEscalationPercentage.touched))">
                    <p class="redtext" *ngIf="txtEscalationPercentage.errors.max">
                      Escalation percentage cannot be greater than 100
                    </p>
                    <p class="redtext" *ngIf="txtEscalationPercentage.errors.min">
                      Escalation percentage cannot be less than 0
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Period</label>
                  <div class="textbox-with-btn textbox-with-4character">
                    <input formControlName="txtEscalationYrs" [class.error-input]="getnullableInput('RentEscalationPeriod')" min="0" [min]="0" [(ngModel)]="model.RentEscalationPeriod" type="text" mask="9999"
                           class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                    <span class="rightlabel">Year(s)</span>
                  </div>
                  <div *ngIf="(txtEscalationYrs.invalid && isSubmitted)||(txtEscalationYrs.invalid && (txtEscalationYrs.dirty || txtEscalationYrs.touched))">
                    <p class="redtext" *ngIf="txtEscalationYrs.errors.min">
                      Escalation period cannot be less than 0
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-bottom-20">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label class="bluelabel">Option</label>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Number</label>
                  <input formControlName="txtOptionNumber" min="0" [(ngModel)]="model.OptionNumber" type="text" mask="999999999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Length</label>
                  <div class="textbox-with-btn textbox-with-4character">
                    <input formControlName="txtOptionLength" min="0" [(ngModel)]="model.OptionLength" type="text" mask="9999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                    <span class="rightlabel">Year(s)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

          </div>
        </div>
        <div style="display:none;">
          <div class="floatinghead clearfix">
            <h2 class="mainhead">
              <span class="text">NOI / Rent Schedule</span>
            </h2>
          </div>
          <div>
            <app-rent-term-table (updateLoadStatus)="updateLoadStatus($event)" (rentTerm)="saveRentTerm($event)" [propertyId]="this.model.Id" [InitialLoad]="InitialLoad" [rentTermsAutoCalc]="retnTermAutoCalcValue" [rentTerms]="rentTerms" [PropertyRentTerms]="model.PropertyRentTerm" [IsEditAllowed]="true"></app-rent-term-table>
          </div>
        </div>
        <div>
        </div>

        <div>
        </div>
      </div>
    </div>
    <div class="ThirdDiv" *ngIf="activeDiv==3">
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Acquisition Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Acquisition Price
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtAcquisitionPrice" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.AcquisitionPrice"
                       class="form-control " value="{{model.AcquisitionPrice|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>

            </div>
          </div>
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Acquisition Cap Rate
              </label>
              <div>
                <div class="textbox-with-btn textbox-with-2character">
                  <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" [class.error-input]="getnullableInput('AcquisitionCapRate')" type="text" mask="999.99" formControlName="txtAcquisitionCapRate" [dropSpecialCharacters]="false" [(ngModel)]="model.AcquisitionCapRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                  <span class="rightlabel">%</span>
                </div>
                <div *ngIf="(txtAcquisitionCapRate.invalid && isSubmitted)||(txtAcquisitionCapRate.invalid && (txtAcquisitionCapRate.dirty || txtAcquisitionCapRate.touched))">
                  <p class="redtext" *ngIf="txtAcquisitionCapRate.errors.max">
                    Acquisition Cap Rate cannot be greater than 100
                  </p>
                  <p class="redtext" *ngIf="txtAcquisitionCapRate.errors.min">
                    Acquisition Cap Rate cannot be less than 0
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Debt Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Lender
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtLender" maxlength="50" [(ngModel)]="model.Lender" class="form-control">
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Loan Amount
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtLoanAmount" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.LoanAmount"
                       class="form-control " value="{{model.LoanAmount|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Interest Rate
              </label>
              <div>
                <div class="textbox-with-btn textbox-with-2character">
                  <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" [class.error-input]="getnullableInput('InterestRate')" type="text" mask="999.99" formControlName="txtInterestRate" [dropSpecialCharacters]="false" [(ngModel)]="model.InterestRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                  <span class="rightlabel">%</span>
                </div>
                <div *ngIf="(txtInterestRate.invalid && isSubmitted)||(txtInterestRate.invalid && (txtInterestRate.dirty || txtInterestRate.touched))">
                  <p class="redtext" *ngIf="txtInterestRate.errors.max">
                    Interest Rate cannot be greater than 100
                  </p>
                  <p class="redtext" *ngIf="txtInterestRate.errors.min">
                    Interest Rate cannot be less than 0
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Amortization
              </label>
              <label class="select">
                <select class="form-control" name="lstAmortization" formControlName="lstAmortization"
                        [(ngModel)]="model.Amortization">
                  <option [ngValue]="null">Select</option>
                  <option [ngValue]="item.id" *ngFor="let item of AmortizationFieldList">{{item.description}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Origination Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" [class.error-input]="getnullableInput('OrginationDate')" name="txtOrginationDate" formControlName="txtOrginationDate"
                       [(ngModel)]="model.OrginationDate" class="form-control" bsDatepicker #dp1="bsDatepicker">
                <i (click)="dp1.toggle()" class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtOrginationDate.invalid && isSubmitted)||(txtOrginationDate.invalid && (txtOrginationDate.dirty || txtOrginationDate.touched))">
                <p class="redtext" *ngIf="model.OrginationDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Maturity Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtMaturityDate" [class.error-input]="getnullableInput('MaturityDate')" formControlName="txtMaturityDate"
                       [(ngModel)]="model.MaturityDate"
                       class="form-control" bsDatepicker #dp2="bsDatepicker">
                <i (click)="dp2.toggle()" class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtMaturityDate.invalid && isSubmitted)||(txtMaturityDate.invalid && (txtMaturityDate.dirty || txtMaturityDate.touched))">
                <p class="redtext" *ngIf="model.txtMaturityDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Prepay
              </label>
              <label class="select">
                <select class="form-control" name="lstPrepay" formControlName="lstPrepay"
                        [(ngModel)]="model.PrePay">
                  <option [ngValue]="null">Select</option>
                  <option [ngValue]="item.lookupValue" *ngFor="let item of PrepayList">{{item.description}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Assumable
              </label>
              <label class="select">
                <select class="form-control" name="lstAssumable" formControlName="lstAssumable"
                        [(ngModel)]="model.Assumable">
                  <option [ngValue]="null">Select</option>
                  <option [ngValue]="item.lookupValue" *ngFor="let item of AssumableList">{{item.description}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="border-div border-div-2" [hidden]="true">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Expense Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Expenses
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtExpenses" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Expenses"
                       class="form-control " value="{{model.Expenses|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Reimbursements
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtExpenseReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.ExpenseReimbursement"
                       class="form-control " value="{{model.ExpenseReimbursement|toNumber|number}}">
                <span class="leftlabel">$</span>

              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Category
              </label>
              <div>
                <div class="textbox-with-btn textbox-with-2character">
                  <input type="text" formControlName="txtExpenseCategory" [(ngModel)]="model.ExpenseCategory" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Commence Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtExpenseCommencement" formControlName="txtExpenseCommencement"
                       [(ngModel)]="model.ExpenceCommenceDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtExpenseCommencement.invalid && isSubmitted)||(txtExpenseCommencement.invalid && (txtExpenseCommencement.dirty || txtExpenseCommencement.touched))">
                <p class="redtext" *ngIf="model.ExpenceCommenceDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Expiration Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtExpenseExpiration" formControlName="txtExpenseExpiration"
                       [(ngModel)]="model.ExpenseExpirationDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtExpenseExpiration.invalid && isSubmitted)||(txtExpenseExpiration.invalid && (txtExpenseExpiration.dirty || txtExpenseExpiration.touched))">
                <p class="redtext" *ngIf="model.ExpenseExpirationDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-div border-div-2" [hidden]="true">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Property Tax</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Tax Paid
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtTax" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Tax"
                       class="form-control " value="{{model.Tax|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Reimbursements
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtTaxReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.TaxReimbursement"
                       class="form-control " value="{{model.TaxReimbursement|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Commence Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtPropertyTaxCommencement" formControlName="txtPropertyTaxCommencement"
                       [(ngModel)]="model.PropertyTaxCommencementDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtPropertyTaxCommencement.invalid && isSubmitted)||(txtPropertyTaxCommencement.invalid && (txtPropertyTaxCommencement.dirty || txtPropertyTaxCommencement.touched))">
                <p class="redtext" *ngIf="model.PropertyTaxCommencementDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Expiration Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtPropertyTaxExpiration" formControlName="txtPropertyTaxExpiration"
                       [(ngModel)]="model.PropertyTaxExpirationDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtPropertyTaxExpiration.invalid && isSubmitted)||(txtPropertyTaxExpiration.invalid && (txtPropertyTaxExpiration.dirty || txtPropertyTaxExpiration.touched))">
                <p class="redtext" *ngIf="model.PropertyTaxExpirationDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-div border-div-2" [hidden]="true">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Insurance Info</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Insurance Paid
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtInsurance" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.Insurance"
                       class="form-control " value="{{model.Insurance|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
            <div class="form-group">
              <label class="form-label">
                Reimbursements
              </label>
              <div class="textbox-with-btn-left">
                <input type="text" formControlName="txtInsuranceReimbursement" dropSpecialCharacters="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" [(ngModel)]="model.InsuranceReimbursement"
                       class="form-control " value="{{model.InsuranceReimbursement|toNumber|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Commence Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtInsuranceCommencement" formControlName="txtInsuranceCommencement"
                       [(ngModel)]="model.InsuranceCommencementDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtInsuranceCommencement.invalid && isSubmitted)||(txtInsuranceCommencement.invalid && (txtInsuranceCommencement.dirty || txtInsuranceCommencement.touched))">
                <p class="redtext" *ngIf="model.InsuranceCommencementDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                Expiration Date
              </label>
              <div class="textbox-date">
                <input type="text" maxlength="10" name="txtInsuranceExpiration" formControlName="txtInsuranceExpiration"
                       [(ngModel)]="model.InsuranceExpirationDate" class="form-control" bsDatepicker>
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
              <div *ngIf="(txtInsuranceExpiration.invalid && isSubmitted)||(txtInsuranceExpiration.invalid && (txtInsuranceExpiration.dirty || txtInsuranceExpiration.touched))">
                <p class="redtext" *ngIf="model.InsuranceExpirationDate =='Invalid Date'">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="FourthDiv" [style.display]="activeDiv==4 ? 'block' : 'none'">
      <div class="border-div border-div-2">
        <div class="d-flex chart-box-header align-item-center margin-bottom-50">
          <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
            <span class="text">Documents & Images</span>
          </h2>
          <div class="like-view-div  margin-right-20">
          </div>
        </div>
        <!--<div class="margin-bottom-20 clearfix" *ngIf="authService.Admin()">
          <div class="rightcheckbox ">
            <label class="custom-checkbox margin-right-20" for="checkbox13">
              <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Offering Memorandum access requires approval
              <i></i>
            </label>

            <label class="custom-checkbox  margin-right-20" for="checkbox14">
              <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Due Diligence access requires approval
              <i></i>
            </label>

            <label class="custom-checkbox " for="checkbox15">
              <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Confidentiality Agreement Required
              <i></i>
            </label>
          </div>
        </div>-->
        <div class="om-dd-check-wrapper margin-bottom-20 d-felx">
          <div style="display:inline-block;" class="inline-block rightcheckbox">
            <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
              <li class="transition  margin-bottom-10">
                <div class="list-filter-div d-flex flex-wrap-wrap">
                  <div class="inner-div  d-flex flex-wrap-wrap">
                    <label>
                      Offering Memorandum:
                    </label>
                    <label class="custom-checkbox margin-right-20" for="checkbox13">
                      <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Requires Approval
                      <i></i>
                    </label>
                    <label class="custom-checkbox margin-right-20" for="checkbox14">
                      <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                      <i></i>
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div style="display:inline-block;" class="inline-block rightcheckbox">
            <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
              <li class="transition">
                <div class="list-filter-div">
                  <div class="inner-div  d-flex flex-wrap-wrap">
                    <label>
                      Due Diligence:
                    </label>
                    <label class="custom-checkbox margin-right-20" for="checkbox15">
                      <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Requires Approval
                      <i></i>
                    </label>
                    <label class="custom-checkbox margin-right-20" for="checkbox14">
                      <input formControlName="chkDDConfidentialityAgreement" [(ngModel)]="model.DDConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                      <i></i>
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="floatinghead clearfix">
          <h3 class="bluelabel">Documents</h3>

          <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Documents" placement="left">
            <input type="file" (change)="onNewFileUpload($event)" multiple #propDoc class="fileupload">
            <span class="icofont icofont-upload-alt icon"></span>
          </div>
          <!--<file-upload (selectedFilesListEmitter)=onNewFileUpload($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
          <label class="alert-danger">{{errorMessageForLOI}}</label>-->
        </div>
        <div>
          mm
          <p class="commonpara">
            <i container="body" class="userpermissiontooltip margin-right-5" aria-hidden="true" placement="right">
              <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
            </i>
            <span>Allowed file types: .PDF</span>
          </p>
        </div>
        <div class="table-responsive margin-bottom-20">
          <table class="table basictable">
            <thead>
              <tr>
                <th style="width:50px">#</th>
                <th>Document Title</th>
                <th>Category</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of propertyDocuments; let i = index;">
                <td>
                  <p>{{i + 1}}</p>
                </td>
                <td>
                  <p>{{doc.Name}}</p>
                </td>
                <td>
                  <label class="select">
                    <select [(ngModel)]="doc.CategoryId" [formControlName]="'cmbDocCat' + getDocId(i)" class="form-control ">
                      <option [ngValue]="null">Select</option>
                      <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                    </select>
                    <i></i>
                  </label>
                  <div *ngIf="(propForm.get('cmbDocCat' + getDocId(i)).invalid && isSubmitted) || (propForm.get('cmbDocCat' + getDocId(i)).invalid && (propForm.get('cmbDocCat' +getDocId(i)).dirty || propForm.get('cmbDocCat' +getDocId(i)).touched))">


                    <p class="redtext" *ngIf="propForm.get('cmbDocCat' +getDocId(i)).errors.required">
                      Document category is required
                    </p>
                  </div>
                </td>
                <td>
                  <a class="view" *ngIf="doc.Url != null && doc.Url.length > 0" href={{doc.Url}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                     ng-reflect-placement="top" triggers="hover">
                    <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                  </a>
                  <a href="javascript:void(0);" (click)="onRemoveDocument(i)" class="remove" tooltip="Remove" placement="top">
                    <i class="icofont icofont-close" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="propertyDocuments.length === 0">
                <td colspan="4" style="text-align: center; font-weight: normal; color: gray">

                  <div class="nodata">
                    <i class="icofont icofont-warning icon"></i>
                    <p>No Documents Added</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--new upload style-->
        <!--<ul class="imglisting informationupload">
            <li class="addnew">
                <input   type="file" (change)="onNewFileUpload($event)" multiple #propDoc>
                <span class="icofont icofont-upload-alt"></span>
                <p>Click here to Upload Documents</p>
            </li>
        </ul>-->
        <!--new upload style ends-->

        <h3 class="bluelabel margin-bottom-15">Property Images</h3>
        <div class="floatinghead clearfix">
          <p class="commonpara">
            (For connectivity below the Wifi speed(like 4G&3G), upload photos with less than 3-4MB size to reduce the upload
            time duration.)
          </p>
          <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Images" placement="left">
            <input #propImage class="fileupload" (change)="onNewImageUpload($event)" multiple type="file">
            <span class="icofont icofont-upload-alt icon"></span>
          </div>
        </div>
        <div class="table-responsive margin-bottom-20">
          <table class="table basictable imglisting">
            <thead>
              <tr>
                <th style="width:50px">#</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>Alt Text</th>
                <th>Caption</th>
                <th>Description</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of propertyImages; let i = index;" class="draggable"
                  [class.active]="draggedOverIndex == i">
                <td>
                  <p>{{i+1}}</p>
                </td>
                <td class="image-div">
                  <div class="img-check" [ngClass]="(i == 0 && isContainsIsDefault()) || file.IsDefault? 'active': ''">
                    <label class="custom-checkbox ">
                      <input type="radio" ondragover="return false" name="default" (click)="setAsDefault(file.Id,i)">
                      <i class="helper"></i>
                    </label>
                  </div>
                  <div class="margin-top-15"><div>Default</div></div>
                </td>
                <td draggable="true"
                    (dragover)="allowDrop($event, i)"
                    (dragstart)="onDragStart(i)"
                    (drop)="onDrop($event,i)" class="img_drag">
                  <span>
                    <img [src]="file.Url" style="width:75px;height:53px;" />
                  </span>
                </td>
                <td>
                  <input class="form-control" ondragover="return false" type="text" maxlength="100" [formControlName]="'txtalText'+getImageId(i)" [(ngModel)]="file.AlText" />
                </td>
                <td>
                  <input class="form-control" ondragover="return false" type="text" [formControlName]="'txtCaption'+getImageId(i)" maxlength="100" [(ngModel)]="file.Caption" />
                  <input class="form-control" type="hidden" [formControlName]="'txtDisplayOrder'+getImageId(i)" />
                </td>
                <td>
                  <textarea class="form-control" ondragover="return false" style="padding:0px 15px !important;" [formControlName]="'txtLongDescription'+getImageId(i)" maxlength="500" [(ngModel)]="file.Description"></textarea>
                </td>
                <td>
                  <a href="javascript:void(0);" ondragover="return false" (click)="onRemoveImage(file.Id,i)" class="remove" tooltip="Remove" placement="top">
                    <i class="icofont icofont-close" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="propertyImages.length === 0">
                <td colspan="7" style="text-align: center; font-weight: normal; color: gray">

                  <div class="nodata">
                    <i class="icofont icofont-warning icon"></i>
                    <p>No Image Added</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row" style="margin-bottom:35px !important;">
        </div>
        <h3 class="bluelabel margin-bottom-10">Videos</h3>
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Paste your vimeo video URL here</label>
              <input formControlName="txtVideoUrl" [class.error-input]="getnullableInput('VideoUrl')" [(ngModel)]="model.VideoUrl" class="form-control " type="text">
              <div *ngIf="(txtVideoUrl.invalid && isSubmitted) || (txtVideoUrl.invalid && (txtVideoUrl.dirty || txtVideoUrl.touched))">
                <p class="redtext" *ngIf="txtVideoUrl.errors.vimeoUrl">
                  Invalid Vimeo video url
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="bottom-btn-wrapper margin-top-20 cf margin-bottom-40">
    <div class="container container-lg">
      <div class="bottom-btn">
        <div class="btn-left">
          <button class="btn-lg btn-border btn adduserbtn margin-right-10" *ngIf="activeDiv!=1" (click)="GoToNext('Back');" style="margin-right:10px !important;"> Back</button>
          <button class="btn-lg btn-border btn adduserbtn" *ngIf="isInEditMode && model.DataEntryPropertyStatusId == 6949" (click)="saveAsDraft(ChangeUpdate,3)"> Save as Draft</button>
          <button class="btn-lg btn-border btn adduserbtn" *ngIf="!isInEditMode" (click)="saveAsDraft(ChangeUpdate,3)"> Save as Draft</button>
        </div>
        <div class="btn-rt">
          <button class="btn btn-border btn-lg" (click)="cancelSave();"> Cancel</button>
          <button class="btn-lg btn-border btn adduserbtn" *ngIf="activeDiv<4" (click)="GoToNext('Next');"> Next</button>
          <button (click)="saveChanges(ChangeUpdate,3)" *ngIf="(((!model.LiveListingId&&!authService.Admin()&&!authService.SuperAdmin())||!model.LiveListingId&&(authService.Admin()||authService.SuperAdmin())&&model.PropertyStatusId == 6906)) && firstDivCompleted && secondDivCompleted" class="btn btn-success btn-lg">Save Property</button>
        </div>
      </div>
    </div>

  </div>
</form>
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCkUOdZ5y7hMm0yrcCQoCvLwzdM6M8s5qk&libraries=places&callback=initAutocomplete"
    async defer></script> -->


<ng-template #ChangeUpdate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">There were some updates on the property source site. Did we capture those in B+E?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(false)">NO</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(true)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForSelection>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">This property will be listed for {{propertyFor}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="modalRefPropertyForSelection.hide()">OK</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForConfirmation>
  <div class="modal-body padding30">
    <div class="form-group" *ngIf="model.SaveAsPrincipalDraft">
      <h6 class="displayvalue">Are you sure you want to save this {{isPortfolio ? 'portfolio' : 'property'}} as Draft? </h6>
    </div>
    <div class="form-group" *ngIf="(authService.Admin()||authService.SuperAdmin()) && !model.SaveAsPrincipalDraft">
      <h6 class="displayvalue">Are you sure you want to list {{ model.TenantName }} for {{propertyFor}} ? </h6>
    </div>
    <div class="form-group" *ngIf="!authService.Admin()&&!authService.SuperAdmin() && !model.SaveAsPrincipalDraft">
      <h6 class="displayvalue">Are you sure you want to submit this {{isPortfolio ? 'portfolio' : 'property'}} for approval? </h6>
    </div>


    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="RemoveConfirm();">NO</button>
      <button class="btn btn-lg btn-success" *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="saveMethod(ChangeUpdate)">YES</button>
      <button *ngIf="!authService.Admin()&&!authService.SuperAdmin()" class="btn btn-lg btn-success" (click)="saveMethod(ChangeUpdate)">Proceed</button>
    </div>
  </div>
</ng-template>



<ng-template #BrokerageBroker>
  <app-brokerage-broker-add [modalRef]="modalRef" [selectedBrokers]="selectedBrokers" [selectedBrokerage]="brokerageName" (addBroker)="addBroker($event);" (closeModal)="closeModalDataEntry($event)" [selectedBrokerageId]="brokerageId"></app-brokerage-broker-add>
</ng-template>

<ng-template #templateAutoCalcRentTerm>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Auto Calculate Rent Term?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Entries will be lost when you check this option. Are you sure you want to proceed?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">No</button>
      <button class="btn btn-lg btn-primary" (click)="setAutoCalcRentTerm();modalRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #templateBrockerDelete>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRemoveBrockerRef.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete broker?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRemoveBrockerRef.hide();">No</button>
      <button class="btn btn-lg btn-primary" (click)="onRemoveBrokers(this.brockerIndex);modalRemoveBrockerRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #Duplicate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">A property with the same tenant name and address exists in the application. Would you like to continue ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDuplicates.hide();">NO</button>
      <button class="btn btn-lg btn-success" (click)="saveMethodAfterDuplicateCheck(ChangeUpdate)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #DuplicateProperties>
  <app-duplicate-properties [duplicatePropertyList]="duplicatePropertyList" [modalRef]="modalRefPrDuplicate"></app-duplicate-properties>
</ng-template>
<ng-template #templateSolidDetails>
  <app-sold-details (save)="addSalesDetails($event)" [property]="model" [currentSalesDetails]="currentSalesDetails" (close)="closeModal($event)"></app-sold-details>
</ng-template>


